import {
  SORT_COLUMNS,
  SORT_DIRECTION,
} from "@/pages/requests/components/users/components/constants";
import styles from "@/pages/requests/components/users/styles.scss";
import { Sort } from "@/assets/icons";
import { SortDirectionsProps } from "@/pages/requests/components/users/components/types";

export const SortButton = ({
  _key,
  sortDirections,
}: {
  _key: SORT_COLUMNS;
  sortDirections: SortDirectionsProps;
}) => {
  return (
    <span className={styles.sortIcon}>
      <Sort
        width={18}
        height={18}
        style={{
          transform:
            sortDirections[_key] === SORT_DIRECTION.ASC
              ? "rotate(180deg)"
              : "rotate(0deg)",
        }}
      />
    </span>
  );
};
